<template>
  <div id="kt_header" class="header header-fixed d-print-none">
    <!--begin::Container-->
    <div class="container-fluid d-flex align-items-stretch justify-content-between">
      <!--begin::Header Menu Wrapper-->
      <!-- <div class="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper"> -->
      <!--begin::Header Menu-->
      <!--end::Header Menu-->
      <!-- </div> -->
      <!--end::Header Menu Wrapper-->
      <!--begin::Topbar-->
      <div class="topbar w-100">
        <div class="topbar-item">
          <span class="font-weight-bolder font-size-h5">
            {{ title }}
          </span>
        </div>
        <!--begin::User-->
        <div class="topbar-item ml-auto" v-if="user">
          <!-- <div class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2" id="kt_quick_user_toggle"> -->
          <div class="dropdown">
            <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2">
              <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1"></span>
              <span class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
                {{ user.nombre }}
              </span>
              <span v-if="user.imagen" class="symbol symbol-35">
                <span
                  class="symbol-label"
                  :style="{
                    backgroundImage: `url(${$storage('/usuarios/fotos/' + user.imagen)})`,
                  }"
                ></span>
              </span>
              <span v-else class="symbol symbol-35 symbol-light-success">
                <span class="symbol-label font-size-h5 font-weight-bold">
                  {{ user.nombre[0] }}
                </span>
              </span>
            </div>
            <div class="dropdown-menu shadow-lg">
              <button @click="onClickLogout" class="dropdown-item" href="#"><i class="fa fa-fw fa-sign-out-alt"></i> Cerrar Sesión</button>
            </div>
          </div>
        </div>
        <!--end::User-->
      </div>
      <!--end::Topbar-->
    </div>
    <!--end::Container-->
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("layout", {
      title: "getTitle",
    }),
  },
  methods: {
    async onClickLogout() {
      try {
        this.axios.post("/auth/logout");
      } catch (error) {}
      this.$store.dispatch("auth/logout");
      this.$router.push({ name: "auth.login" });
    },
  },
};
</script>
